export const webClientId = '430505235194-j3r50fkj9o995dt6nfipioiq2ibfiu9j.apps.googleusercontent.com'